import * as React from 'react';
import { IconProps } from '../types';

const IcCashierZoomIn = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M11.5 3.667a7.333 7.333 0 1 0 5.108 12.595.67.67 0 0 1 .154-.154A7.333 7.333 0 0 0 11.5 3.667Zm6.581 12.972a8.667 8.667 0 1 0-.943.943l3.89 3.89a.667.667 0 1 0 .943-.943l-3.89-3.89ZM11.5 7.333c.368 0 .667.299.667.667v2.333H14.5a.667.667 0 1 1 0 1.334h-2.333V14a.667.667 0 0 1-1.334 0v-2.333H8.5a.667.667 0 0 1 0-1.334h2.333V8c0-.368.299-.667.667-.667Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcCashierZoomIn;
